import type { EditorConfig } from 'ckeditor5';
import { environment } from 'src/environments/environment';
import { createPlaceholderChipPlugin, FrameLabels } from './placeholder-chip.plugin';

type CK = typeof import('ckeditor5');

export interface CKEditorPluginConfig {
    plugins: NonNullable<EditorConfig['plugins']>;
    toolbar: string[];
    licenseKey?: string;
}

export function getCKEditorPluginConfig(ck: CK, includeChipPlugin = false, resolveLabel?: (path: string) => string, frameLabels?: FrameLabels): CKEditorPluginConfig {
    const plugins: NonNullable<EditorConfig['plugins']> = [
        ck.Essentials, ck.Bold, ck.Italic, ck.Underline, ck.Strikethrough, ck.Subscript, ck.Superscript,
        ck.Paragraph, ck.Heading, ck.List, ck.Link, ck.Table, ck.TableToolbar, ck.TableCellProperties,
        ck.TableProperties, ck.TableColumnResize, ck.TableCaption, ck.Alignment, ck.Indent, ck.IndentBlock,
        ck.BlockQuote, ck.FontSize, ck.FontColor, ck.FontBackgroundColor, ck.FontFamily, ck.HorizontalLine,
        ck.RemoveFormat, ck.SpecialCharacters, ck.SpecialCharactersEssentials, ck.FindAndReplace,
        ck.Undo, ck.Highlight, ck.GeneralHtmlSupport, ck.ImageBlock, ck.ImageUpload, ck.ImageInsert, ck.ImageCaption, ck.ImageToolbar,
        ck.AutoImage, ck.PasteFromOffice, ck.Widget, ck.Base64UploadAdapter
    ];

    if (includeChipPlugin) {
        plugins.push(createPlaceholderChipPlugin(ck, resolveLabel, frameLabels) as NonNullable<EditorConfig['plugins']>[number]);
    }

    const toolbar: string[] = [
        'undo', 'redo', '|', 'heading', '|', 'fontFamily', 'fontSize', '|',
        'bold', 'italic', 'underline', 'strikethrough', '|',
        'fontColor', 'fontBackgroundColor', 'highlight', '|', 'alignment', '|',
        'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|',
        'blockQuote', 'insertTable', 'link', 'horizontalLine', '|',
        'subscript', 'superscript', 'specialCharacters', 'findAndReplace', 'removeFormat', '|',
        'insertImage'
    ];

    const licenseKey = (environment as { ckeditorLicenseKey?: string }).ckeditorLicenseKey;

    return {
        plugins,
        toolbar,
        ...(licenseKey ? { licenseKey } : {})
    };
}
